import { FormGroup, FormParagraph, Text } from '@ksyos/design-system';
import type { ValidationErrors } from '../../../../utils/validation';
import type { OrthOExaminationOrder } from './orthOExaminationOrder';
import { InputText } from '../../../userDataManagement/InputText';

interface IOrthOV1Procedure30cm6mMeasurementsProps {
    errors?: ValidationErrors;
    field: string;
    hasErrors?: boolean;
    isReadOnly?: boolean;
    isRequired?: boolean;
    label: string;
    tabIndex: OrthOExaminationOrder;
    value_30?: string | null;
    value_6?: string | null;
}

export function OrthOV1Procedure30cm6mMeasurements(props: IOrthOV1Procedure30cm6mMeasurementsProps) {
    if (props.isReadOnly) {
        return (
            <>
                {(props.value_30 || props.value_6) && (
                    <FormGroup label={props.label}>
                        <FormParagraph>
                            {props.value_30 && (
                                <span>
                                    30cm - {props.value_30} <br />
                                </span>
                            )}
                            {props.value_6 && <span>6m - {props.value_6}</span>}
                        </FormParagraph>
                    </FormGroup>
                )}
            </>
        );
    } else {
        return (
            <FormGroup
                hasErrors={props.hasErrors}
                isRequired={props.isRequired}
                label={props.label}
            >
                <div className="row">
                    <div className="col-sm-12">
                        <Text
                            color="minimal"
                            size="sm"
                        >
                            30 cm
                        </Text>
                        <InputText
                            error={props.errors?.get(`customControlData.${props.field}_30cm`)}
                            fieldKey={`${props.field}_30cm`}
                            placeholder="Bevindingen..."
                        />
                    </div>
                    <div className="col-sm-12">
                        <Text
                            color="minimal"
                            size="sm"
                        >
                            6m
                        </Text>
                        <InputText
                            error={props.errors?.get(`customControlData.${props.field}_6m`)}
                            fieldKey={`${props.field}_6m`}
                            placeholder="Bevindingen..."
                        />
                    </div>
                </div>
            </FormGroup>
        );
    }
}
